export const NOT_FOUND = -1;
export const NOT_ACTIVATED = -2;
export const BLOCKED = -5;
export const WRONG_CERT = -3;
export const WRONG_PASSWORD = -4;


// WEBPACK FOOTER //
// ./js/constants/AuthError.js